import { FadeIn } from "@/components/FadeIn";

const steps = [
  {
    numeral: "I",
    label: "Erzählen",
    desc: "Sie beantworten in Ruhe einige stille Fragen — wer war dieser Mensch, was hat ihn ausgemacht.",
  },
  {
    numeral: "II",
    label: "Erstellen",
    desc: "Aus Ihren Worten entsteht ein erster Entwurf. Ruhig formuliert, in Ihrer Perspektive.",
  },
  {
    numeral: "III",
    label: "Verfeinern",
    desc: "Sie erhalten den Text. Lesen, ändern, anpassen — bis er sich wie Ihrer anfühlt.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="pt-16 pb-24 md:pt-20 md:pb-36">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="label-eyebrow mb-6">Wie es funktioniert</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal max-w-2xl leading-[1.1]">
            In drei stillen Schritten.
          </h2>
        </FadeIn>

        <div className="mt-20 grid md:grid-cols-3 gap-12 md:gap-16">
          {steps.map((s, i) => (
            <FadeIn key={s.label} delay={0.1 + i * 0.1}>
              <div data-testid={`how-step-${i + 1}`} className="flex flex-col">
                <div className="mb-10">
                  <span className="font-serif text-6xl md:text-7xl text-umber italic leading-none tracking-tight">
                    {s.numeral}
                  </span>
                  <span className="ml-3 font-display tracking-[0.3em] text-[10px] text-umber align-super">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-charcoal mb-4 leading-tight">
                  {s.label}
                </h3>
                <div className="w-8 h-px bg-umber/40 mb-6" />
                <p className="font-serif text-lg text-ink leading-relaxed">{s.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
